import type { AdminInstitution } from '@front/type/admin'

import type { Device } from './device'
import { ShiftApplicationState } from '@hublo/enums'

export type SegmentHubloPoolApplicationStatusType =
  | 'Subscribed'
  | 'Pending'
  | 'Deleted'
  | 'Not registered'

export type SegmentWorkerProperties = {
  userId?: string
  idWorker?: number
  medium?: Device
  firstName?: string
  lastName?: string
  email?: string
  institutionId?: string[]
  phone?: string
  type: 'Worker'
  lang?: string
  hublerId?: string
  createdAt?: string
  pool?: SegmentHubloPoolApplicationStatusType
  poolAcceptedAt?: string
}

// to be completed when needed
export type SegmentAdminProperties = {
  userId: string
  idAdmin?: number
  medium: Device
  firstName?: string
  lastName?: string
  email?: string
  institutions?: Pick<AdminInstitution, 'id' | 'name'>[]
  phone?: string
  type: 'Admin'
  lang: string
}

export type SegmentShiftApplicationStatusType =
  | 'Accepted'
  | 'Declined by Institution'
  | 'Declined by Hubler'
  | 'Canceled'
  | 'Pending'
  | 'To fill'

type SegmentUserProperties = SegmentWorkerProperties | SegmentAdminProperties

export type SegmentAvailabilitiesQuickFillProperties = {
  isAvailable: boolean
  isDay: boolean
  isNight: boolean
  beginat: string
  endat: string
  slotType: string
}

export type SegmentAdditionalProperties = Record<string, unknown>

export type SegmentProperties = SegmentUserProperties &
  SegmentAdditionalProperties

export const shiftStatusToSegmentStatus = (
  applicationState?: ShiftApplicationState,
): SegmentShiftApplicationStatusType => {
  switch (applicationState) {
    case ShiftApplicationState.ACCEPTED:
    case ShiftApplicationState.ASSIGNED:
      return 'Accepted'
    case ShiftApplicationState.DECLINED:
      return 'Declined by Institution'
    case ShiftApplicationState.DECLINED_BY_HUBLER:
    case ShiftApplicationState.WITHDRAWN:
      return 'Declined by Hubler'
    case ShiftApplicationState.ABORTED:
    case ShiftApplicationState.CANCELED:
      return 'Canceled'
    case ShiftApplicationState.PENDING:
      return 'Pending'
    default:
      return 'To fill'
  }
}
